export const addMedicineStockTranslations = {
    en: {
        currentStock: "Current Stock",
        units: "units",
        enterQuantityPrompt: "Enter the quantity to add to the inventory.",
        quantityToAdd: "Quantity to Add",
        quantityError: "Quantity must be greater than 0",
        addStock: "Add Stock",
        stockAddedSuccess: "Stock Added Successfully"
    },
    mr: {
        currentStock: "सध्याचा साठा",
        units: "युनिट्स",
        enterQuantityPrompt: "इन्व्हेंटरीमध्ये जोडण्यासाठी प्रमाण प्रविष्ट करा.",
        quantityToAdd: "जोडण्यासाठी प्रमाण",
        quantityError: "प्रमाण 0 पेक्षा जास्त असणे आवश्यक आहे",
        addStock: "साठा जोडा",
        stockAddedSuccess: "साठा यशस्वीरित्या जोडला"
    }
};
